// เก็บเป็น array ที่มีรู (null) ห้ามบีบให้ชิด — ปิดกรอบเดียวแล้วกรอบอื่นต้องอยู่ที่เดิม ไม่เลื่อนตำแหน่ง

import { useCallback, useMemo, useState } from 'react'

function padTo(list, size) {
  const next = list.slice()
  while (next.length < size) next.push(null)
  return next
}

function firstEmpty(list, size) {
  for (let i = 0; i < size; i += 1) {
    if (!list[i]) return i
  }
  return -1
}

export default function useWallSlots(initialLayout) {
  const [layout, setLayout] = useState(initialLayout)
  const [slotIds, setSlotIds] = useState([])
  const [focusIndex, setFocusIndex] = useState(0)

  const changeLayout = useCallback(next => {
    setLayout(next)
    setSlotIds(prev => prev.slice(0, next))
    setFocusIndex(prev => (prev < next ? prev : 0))
  }, [])

  const toggle = useCallback(
    vehicleId => {
      setSlotIds(prev => {
        const at = prev.indexOf(vehicleId)
        if (at !== -1) {
          const next = prev.slice()
          next[at] = null
          return next
        }

        const next = padTo(prev, layout)
        const empty = firstEmpty(next, layout)
        if (empty !== -1) {
          next[empty] = vehicleId
          return next
        }

        next[focusIndex < layout ? focusIndex : 0] = vehicleId
        return next
      })
    },
    [layout, focusIndex],
  )

  const remove = useCallback(vehicleId => {
    setSlotIds(prev => prev.map(id => (id === vehicleId ? null : id)))
  }, [])

  const clear = useCallback(() => setSlotIds([]), [])

  const focus = useCallback(vehicleId => {
    setSlotIds(prev => {
      const at = prev.indexOf(vehicleId)
      if (at !== -1) setFocusIndex(at)
      return prev
    })
  }, [])

  const buildSlots = useCallback(
    vehiclesById => {
      const slots = new Array(layout).fill(null)
      for (let i = 0; i < layout; i += 1) {
        const id = slotIds[i]
        slots[i] = id ? vehiclesById[id] || null : null
      }
      return slots
    },
    [slotIds, layout],
  )

  /** ไม่มีรู — body ของ /getlistvehiclehoneytoast กับตารางรถรับ null ไม่ได้ */
  const ids = useMemo(() => slotIds.filter(Boolean), [slotIds])

  const selectedId = useMemo(() => slotIds[focusIndex] || null, [
    slotIds,
    focusIndex,
  ])

  return {
    layout,
    ids,
    selectedId,
    changeLayout,
    toggle,
    remove,
    clear,
    focus,
    buildSlots,
  }
}
